import axios from 'axios';

export default class WebsitesService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>('admin/cms/websites', {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async getOptions()
    {
        return (await axios.get<OptionsModel[]>('admin/cms/websites/options')).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/websites/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(`admin/cms/websites`, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Statement>(`admin/cms/websites/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/cms/websites/${id}`)).data as Statement;
    }

    public static async getSearchableModules()
    {
        return (await axios.get(`admin/cms/websites/elasticsearch/available-modules`)).data;
    }

    public static async getDefault(): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`admin/cms/websites/default`)).data;
    }
}

export interface SearchableModuleModel
{
    searchableModules: string[];
    studioModules: StudioModuleModel[];
}

export interface StudioModuleModel
{
    name: string;
    sections: StudioSectionModel[];
}

export interface StudioSectionModel
{
    id: string;
    name: string;
}

export interface ListItemModel
{
    id: number;
    name: string;
    title: string;
    defaultTheme: string;
    isActive: boolean;
    isDefault: boolean;
}

export interface OptionsModel
{
    id: number;
    title: string;
    locales: string[];
    defaultLocale: string;
    defaultTheme: string;
    baseUrl: string;
    isSecured: boolean;
    modules: string[];
    widgets: string[];
    searchableModules: string[];
}

export interface FilterModel
{
    name: string;
    title: string;
    theme: string;
    isActive?: boolean;
    isDefault: boolean;
}

export interface FormModel
{
    id: number;
    name: string;
    title: string;
    isActive: boolean;
    isDefault: boolean;
    isSecured: boolean;
    authOnly: boolean;
    cacheEnabled: boolean;
    baseUrl: string;
    locales: string[];
    activeLocales: string[];
    defaultLocale: string;
    defaultTheme: string;
    modules: string[];
    widgets: string[];
    searchableModules: string[];
    meta: MetaSettingsModel | null;
    logo?: File;
    cookiesInfo: Record<string, string>;
    favIcon?: File;
    errorHtmlText: string;
    statisticsScripts: string;
    targetingScripts: string;
    googleAnalyticsPropertyId: string;
    googleAnalyticsAuthJson: string;
    gtmLoadImmediately: boolean;
    technicalBreak: boolean;
    technicalBreakTitle: string;
    technicalBreakDescription: string;
    statisticsScriptsMainSite: string;
    targetingScriptsMainSite: string;
}
